import { IComponentController } from 'angular';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IFormulaire, IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IPaginationClass } from '../../../../../core/services/pagination.service';
import { IMenuItemActionClass } from "../../../../../core/services/menu/menu-item-action.service";
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';

interface IPageGS0069 extends IComponentController {
    monoOccurrence: IMonoOccurrence,
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    aeeMultiOccurrence: IMultiOccurrence;
    formulaireAve: IFormulaire;
    aeeMultiOccurrenceOptions: IMultiOccurrenceOptions;
    gtrMultiOccurrenceOptions: IMultiOccurrenceOptions;
}

/* @ngInject */
export default function Gs0069Controller(
    ecranDetails: IEcranDetailsResourcesEntite,
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    Pagination: IPaginationClass,
    $stateParams: any,
    MenuItemAction: IMenuItemActionClass,
) {

    const vm: IPageGS0069 = this;

    // Valeurs provenant du package gs0069, prb_obtenir_valeurs
    vm.valeursEcran = ecranDetails.valeurs;

    vm.$onInit = function $onInit() {
        vm.monoOccurrenceOptions = {
            menus: [new MenuItemAction("LBL_BTN_ENV", "BOUENV", () => ({}), {
                iconButton: false,
                class: 'md-raised ex-button-action',
                saveFirst: true,
                successAction: () => { 
                    vm.valeursEcran.aveflgprtenv = 1; 
                    vm.monoOccurrence.fetchData();
                    vm.aeeMultiOccurrence.fetchDataList();
                    vm.$onInit();
                },
                disabled: () => estPretAEnvoyer(),
            })],
            fonctions: {
                afficherMenusDansEntete: true,
                boutonDupliquer: !estPretAEnvoyer(),
                supprime: !estPretAEnvoyer(),
            }
        };
        // bouton Nouveau et enlever les actions Modifier supprimer Dupliquer
        //Avis
        vm.formulaireAve = new Formulaire('LBL_BLC_AVE', [
            // cachées
            new FormulaireItem('xyzcleint', { default: $stateParams.xyzcleint }),
            new FormulaireItem('aveflgprtenv', { default: 0 }),
            // visible
            new FormulaireItem('avedatavi'),
            new FormulaireItem('aveflgpor', { default: 1 }),
            new FormulaireItem('aveflgcou', { default: 0 }),
            new FormulaireItem('aveflgdom', { default: 0 }),
            new FormulaireItem('avesuj'),
            new FormulaireItem('avetxt', { largeur: 50 }),
        ], { largeurDefaut: 25 });

        vm.aeeMultiOccurrenceOptions = {
            bloc: 'aee',
            pagination: new Pagination({
                nombreElementPage: 50,
                nbElementsPossibles: [20, 50, 100]
            }),
            fonctions: {
                editionRapide: !estPretAEnvoyer(),
                nouveau: !estPretAEnvoyer(),
                importation: true,
                boutonDupliquer: !estPretAEnvoyer(),
                supprime: !estPretAEnvoyer(),
                edition: !estPretAEnvoyer(),
            },
            colonnesVisibles: [
                { nom: 'employe', largeur: 150 },
                { nom: 'eplnomprn', largeur: 250 }
            ],
            formulaire: new Formulaire([
                new FormulaireItem('demcleint', { largeur: 100 })
            ]),
            colonnesEditionRapide: [
                { nom: 'demcleint', largeur: 450 }
            ]
        };

        function estPretAEnvoyer() : boolean {
            // flag du "prêt à envoyer" dont la valeur provient du package gs0069, prb_obtenir_valeurs
            return vm.valeursEcran.aveflgprtenv;
        }

        // vm.gtrMultiOccurrenceOptions = {
        //     bloc: 'gtr',
        //     colonnesVisibles: [
        //         //@TODO à compléter quand la transversale sera développé
        //     ]
        // };
    }
}
